import type { FieldError } from "react-hook-form";

import { NormalText } from "@/components/text/NormalText";

export function FormFieldError({
  error,
}: {
  error: FieldError["message"] | null;
}) {
  if (error === null || error === undefined) {
    return null;
  }

  return (
    <NormalText elementType="p" className="text-red-500">
      {error}
    </NormalText>
  );
}
